import { useId } from "react";

// Thin geometric heart wordmark icon, dark-glam fuchsia with subtle glow.
export default function LuvmeIcon({ className = "w-7 h-7", animated = false }) {
  const id = useId().replace(/:/g, "");
  const grad = `lg-${id}`;
  const glow = `gl-${id}`;
  const heart = "M24 41 C10 32 5 24 5 16.5 C5 10.5 9.5 6.5 14.8 6.5 C18.7 6.5 21.9 8.8 24 12.2 C26.1 8.8 29.3 6.5 33.2 6.5 C38.5 6.5 43 10.5 43 16.5 C43 24 38 32 24 41 Z";
  return (
    <svg viewBox="0 0 48 48" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Luvme">
      <defs>
        <linearGradient id={grad} x1="6" y1="6" x2="42" y2="42" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FF5FB0" />
          <stop offset="0.55" stopColor="#E91E8C" />
          <stop offset="1" stopColor="#B01268" />
        </linearGradient>
        <filter id={glow} x="-40%" y="-40%" width="180%" height="180%">
          <feGaussianBlur stdDeviation="1.4" result="b" />
          <feMerge>
            <feMergeNode in="b" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      {/* soft outer glow */}
      <path d={heart} stroke="#E91E8C" strokeOpacity="0.35" strokeWidth="4.5" strokeLinejoin="round" strokeLinecap="round" filter={`url(#${glow})`} />
      {/* main geometric outline */}
      <path
        d={heart}
        stroke={`url(#${grad})`}
        strokeWidth="2.4"
        strokeLinejoin="round"
        strokeLinecap="round"
        className={animated ? "luvme-heart-draw" : ""}
      />
      {/* inner geometric accent line */}
      <path d="M24 33 C16 27.5 12.5 22.5 12.5 17.6" stroke={`url(#${grad})`} strokeOpacity="0.5" strokeWidth="1.3" strokeLinecap="round" />
    </svg>
  );
}
